import { render, staticRenderFns } from "./TosfApplicationForm.vue?vue&type=template&id=7ff22546&scoped=true"
import script from "./TosfApplicationForm.vue?vue&type=script&lang=js"
export * from "./TosfApplicationForm.vue?vue&type=script&lang=js"
import style0 from "./TosfApplicationForm.vue?vue&type=style&index=0&id=7ff22546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff22546",
  null
  
)

export default component.exports